import React from "react";
import { IonPage, IonContent, IonToolbar, IonIcon, IonText, IonButton, IonHeader, IonButtons } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './KycRejected.css';
import { alertOutline, closeOutline } from "ionicons/icons";

import { App, BackButtonListenerEvent } from '@capacitor/app';
import AppHeader from "../../../components/AppHeader/AppHeader";

type MyModalProps = {

    closeAction: Function;

}

const KycRejected: React.FC<MyModalProps> = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <AppHeader
                title={t('kyc.rejected.HEADER') as string}
                />
             
            </IonHeader>
            <IonContent>
                <div className="ion-text-center">
                    
                    <div className="ion-text-center">
                        <IonIcon icon={alertOutline} className="kycFlowRejectedIcon" color="danger"></IonIcon>
                    </div>

                    <IonText color="medium" className="ion-text-center">
                        <p className="kycRejectedSubheaderText ion-text-wrap">{t('kyc.rejected.SUBHEADER')}</p>
                    </IonText>

                </div>


            </IonContent>
        </IonPage>
    )

}

export default KycRejected